import * as UI from "@iyk/ui"
import { Assets } from "../../../packages/assets.ts"
import { HowItWorksSheet } from "./how-it-works-sheet.tsx"
import { Link, Routes } from "./link.tsx"

export const Stations = ({ stations, profileId }: Stations.Props) => {
  const numVisited = stations.filter((station) => station.userCheckedIn).length

  return (
    <HowItWorksSheet.Root>
      <section className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <h2>Stations visited</h2>
          <p className="text-xs-upper text-gray-11">
            {numVisited}/{stations.length}
          </p>
        </div>
        <div className="grid grid-cols-2 gap-1">
          {stations.map((station) => {
            if (station.userCheckedIn && profileId) {
              return (
                <Station key={station.id} profileId={profileId} thumbnail={station.thumbnail} />
              )
            }

            return <IdleStation key={station.id} thumbnail={station.thumbnail} />
          })}
        </div>
      </section>

      <HowItWorksSheet.Trigger
        className={UI.classForButton({
          size: "lg",
          kind: "shaded",
          className: "relative w-full font-departure-mono text-xs-upper",
        })}
      >
        <span
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${Assets.images.buttonTexture})` }}
        />
        <span className="relative z-10">How to play</span>
        <UI.Icon.Question className="absolute z-10 right-4" />
      </HowItWorksSheet.Trigger>
    </HowItWorksSheet.Root>
  )
}

const Station = ({ profileId, thumbnail }: { profileId: string; thumbnail: string }) => (
  <Link to={Routes.collection(profileId)} className={classForStation({ visited: true })}>
    <img className="size-28 object-contain" src={thumbnail} />
    <div className="absolute bottom-1 right-1 size-4 rounded-full bg-gray-1 bshadow bshadow-grayA-3 flex items-center justify-center">
      <UI.Icon.Check className="size-3" />
    </div>
  </Link>
)

const IdleStation = ({ thumbnail }: { thumbnail: string }) => (
  <HowItWorksSheet.Trigger>
    <div className={classForStation({ visited: false })}>
      <img className="size-28 object-contain" src={thumbnail} />
    </div>
  </HowItWorksSheet.Trigger>
)

const classForStation = UI.cva(
  ["relative aspect-square bg-background bshadow bshadow-grayA-3 flex items-center justify-center"],
  {
    variants: {
      visited: {
        true: ["bg-gray-3"],
        false: ["bg-gray-1 [&>img]:opacity-50"],
      },
    },
  },
)

export namespace Stations {
  export type Props = {
    stations: Array<{ id: string; name: string; thumbnail: string; userCheckedIn: boolean }>
    profileId?: string
  }
}
